import React from "react";
import { graphql } from "gatsby";
import { TitleBlock as TitleBlockComponent } from "@zempler/theme/src/components/titleBlock/TitleBlock";

export const TitleBlock = ({ data, ...rest }) => (
  <TitleBlockComponent {...data} />
);

export const TitleBlockQuery = graphql`
  fragment TitleBlock on UMBRACO_TitleBlockComponentType {
    heading
    subHeading: subheading
    centered: centred
    style
  }
`;
